/**
 * AuthLayout Component
 * 
 * CloudScape-based layout structure for all authentication pages.
 * Provides consistent header, footer, and centered content area.
 */

import {
    AppLayout,
    Box,
    Container,
    ContentLayout,
    Header,
    SpaceBetween
} from '@cloudscape-design/components';
import React from 'react';

export interface AuthLayoutProps {
  children: React.ReactNode;
  title?: string;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children, title }) => {
  return (
    <AppLayout
      navigationHide
      toolsHide
      headerSelector="#header"
      footerSelector="#footer"
      content={
        <ContentLayout
          header={
            <Box padding={{ top: 'l', bottom: 'l', left: 'l' }}>
              <img 
                src="/nodegeeks-logo.jpg" 
                alt="NodeGeeks" 
                style={{ height: '60px', width: 'auto' }}
              />
            </Box>
          }
        >
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center',
            padding: '0 16px'
          }}>
            <div style={{ 
              width: '100%', 
              maxWidth: '400px'
            }}>
              <Container>
                <SpaceBetween size="l">
                  {title && (
                    <Header variant="h2">{title}</Header>
                  )}
                  {children}
                </SpaceBetween>
              </Container>
            </div>
          </div>
        </ContentLayout>
      }
    />
  );
};
